// extracted by mini-css-extract-plugin
module.exports = {"container":"embed-task_container__ggOAL","icon":"embed-task_icon__5Qid1","button":"embed-task_button__b8NcT","skeleton_animate":"embed-task_skeleton_animate__b5sEf"};